'use strict';

import user from './user.js';

const callbacks = $.Callbacks("cfsShortlistUpdates");

export default {
	maxItems: 30,

	get: () => {
		return user.getCfsShortlist();
	},

	count: () => {
		return user.getCfsShortlist().length;
	},

	add: (id) => {
		user.addToCfsShortlist(id);
		callbacks.fire('added');
	},

	delete: (id) => {
		user.deleteFromCfsShortlist(id);
		callbacks.fire('deleted');
	},

	subscribe: (callback) => {
		callbacks.add(callback);
	}
};
